export const reportingQueryKeys = {
	reports: {
		all: ["reports"] as const,
		list: (status: string) => ["reports", "list", status] as const,
		summary: (status: string) => ["reports", "summary", status] as const,
		byClub: (clubId: string, status: string) => ["reports", "club", clubId, status] as const,
	},
	playerReports: {
		all: ["player-reports"] as const,
		list: (status: string) => ["player-reports", "list", status] as const,
		summary: (status: string) => ["player-reports", "summary", status] as const,
		byPlayer: (playerId: string, status: string) =>
			["player-reports", "player", playerId, status] as const,
	},
	messageReports: {
		all: ["message-reports"] as const,
		list: (status: string) => ["message-reports", "list", status] as const,
	},
	feedback: {
		all: ["feedback"] as const,
		list: (filters?: Record<string, unknown>) => ["feedback", "list", filters ?? {}] as const,
		detail: (id: string) => ["feedback", id] as const,
	},
} as const;
